import { mapEventType } from '../../helper/map-event-type';
import type { PerformanceEventConfig } from '../../types';

export const eventType = (config: PerformanceEventConfig) => {
	return {
		'event:type': mapEventType(config.type),
	};
};
